import { customSeriesDefaultOptions, CustomSeriesOptions } from 'lightweight-charts'
import { SeriesSourceOptions } from '../../chart.typings'

export type BaselineSeriesOptions = CustomSeriesOptions & SeriesSourceOptions & {
    baseValue: number,
    topLineColor: string,
    topFillColor1: string,
    topFillColor2: string,
    bottomLineColor: string,
    bottomFillColor1: string,
    bottomFillColor2: string
    /** Stroke width in CSS pixels (multiplied by devicePixelRatio in the renderer). */
    lineWidth?: number
}

export const defaultOptions: BaselineSeriesOptions = {
    ...customSeriesDefaultOptions,
    source: "close",
    baseValue: 50,
    lineWidth: 2,
    topLineColor: '#089981',
    bottomLineColor: '#f23645',
    topFillColor1: '#08998100',
    topFillColor2: '#08998147',
    bottomFillColor1: '#f2364500',
    bottomFillColor2: '#f2364547',
}
